/**
* 头部菜单
*/
<template>
  <div class="submenu">
    <el-row>
      <!-- <el-col :span="2">
        <hamburger
          class="collapse-btn"
          id="hamburger-container"
          :is-active="!sidebar.opened"
          @toggleClick="collapseChage"
        />
      </el-col> -->
      <!-- <el-col :span="16">
        <span>剩余天数: [{{ residueDate }}天] </span>
        <span>剩余空间: [{{ freeSpace }}M] </span>
        <span>已用空间: [{{ usedSpace }}M] </span>
        <span>空间大小: [{{ DefaultSpace }}M] </span>
        <span style="width: 400px; padding-top: 10px">
          <el-progress :percentage="percent" style="width: 70%"></el-progress
        ></span>
      </el-col> -->
      <el-col :span="8">
        <span style="color: #606266">欢迎您，[{{ user.userDept }}][{{ user.userName }}]</span>
        <!-- <el-link @click="changePassword" :underline="false">修改密码</el-link> -->
        <el-link @click="exit" :underline="false" style="margin-right: 30px">退出登录</el-link>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import router from "../router";
import Hamburger from "./sliderButton";
import { mapGetters } from "vuex";
export default {
  name: "navcon",
  data() {
    return {
      user: [],
      companyst: "",
      residueDate: 0,
      freeSpace: 0,
      usedSpace: 0,
      DefaultSpace: 0,
      percent: 0,
      routerLink: ""
    };
  },
  components: {
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar"]),
  },

  mounted() {
    //加载时获取全局参数   公司名称
    this.user = this.$store.state.loginData[0];
    this.companyst = this.$store.state.companyName;
    this.routerLink = this.$route.name;
  },

  methods: {
    // 退出登录
    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          setTimeout(() => {
            if (this.routerLink.indexOf('admin') != -1) {
              this.$router.push({ path: "/admin666" });
            } else {
              this.$router.push({ path: "/" });
            }
            this.$store.commit("logout", "false");
            this.$store.commit("getGlobalRoute", this.$route.meta.index);
            this.$message({
              type: "success",
              message: "已退出登录!",
            });
          }, 1000);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 修改密码
    changePassword() {
      this.$store.commit("logout", "false");
      this.$router.push({ path: "/changePassword" });
    },
    collapseChage() {
      this.$store.dispatch("toggleSideBar");
    },
  },
};
</script>
<style lang="less" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}

.submenu {
  width: 100%;
  float: right;
  /* background: #353b47; */
}

.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}

.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}

.showimg:active {
  border: none;
}

.el-row {
  position: relative;
}

.el-col {
  height: 25px;
}

.el-col-16 {
  height: 25px;
  line-height: 40px;
  padding-left: 20px;
  font-size: 16px;

  span {
    margin-right: 10px;
    display: inline-block;
    float: left;
  }
}

.el-col-8 {
  float: right;
  text-align: right;
  font-size: 13px;
  height: 25px;
  line-height: 25px;
  padding-top: 7px;
}

.el-link {
  /* color: white; */
  margin-right: 0.1rem;
  margin-left: 0.08rem;
  font-size: 0.22rem;
}

.collapse-btn {
  width: 20px;
  height: 20px;
  line-height: 20px;
  float: left;
  cursor: pointer;
  position: absolute;
  bottom: 35%;
  left: 0;
  z-index: 999;
  font-size: 0.12rem;
  color: black;
  text-align: center;
  transition: all 0.4s;
}

.collapse-btn i {
  transition: all 0.4s;
}

/deep/.el-progress-bar__outer {
  height: 18px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/navcon2.vue